import './interfaces';

class FaqSearch {
	private readonly searchInput: HTMLInputElement;
	private readonly resultContainer: HTMLElement;
	private readonly container: HTMLElement;
	private resultItems: NodeListOf<HTMLLIElement>;
	private selectedItem: number;

	constructor(target: HTMLElement) {
		this.container = target;

		this.searchInput = this.container.querySelector('input[type=search]');
		this.resultContainer = this.container.querySelector('.results');

		if (!this.searchInput && !this.resultContainer) {
			return;
		}

		this.searchInput.addEventListener('input', () => this.onInput());
		this.searchInput.addEventListener('focus', () => this.onInput());
		this.searchInput.addEventListener('keydown', (event: KeyboardEvent) =>
			this.onKeyDown(event)
		);
		document.addEventListener('click', (event) => this.onBlur(event));
	}

	private onInput(): void {
		if (this.searchInput.value.length) {
			const results: Array<FaqItem> = [];

			window.FAQs.forEach((element: FaqItem) => {
				if (element.title.toLowerCase().includes(this.searchInput.value.toLowerCase())) {
					results.push(element);
				}
			});

			this.renderResults(results.slice(0, 6));
		} else {
			this.clearResults();
		}
	}

	private onBlur(event: Event): void {
		if (event.target !== this.searchInput) {
			this.clearResults();
		}
	}

	private onKeyDown(event: KeyboardEvent): void {
		switch (event.key) {
			case 'Enter':
				this.setSelectedItem();
				break;
			case 'ArrowDown':
			case 'ArrowUp':
				this.focusNextListItem(event.key);
				break;
			case 'Escape':
				this.clearResults();
				break;
			default:
				break;
		}
	}

	private setSelectedItem(): void {
		if (this.resultItems && this.resultItems[this.selectedItem]) {
			window.location.href = this.resultItems[this.selectedItem].querySelector('a').href;
		}
	}

	private clearResults(): void {
		this.resultContainer.innerHTML = '';
		this.selectedItem = -1;
	}

	private focusNextListItem(key: string): void {
		if (key === 'ArrowUp') {
			this.selectedItem =
				this.selectedItem > 0 ? this.selectedItem - 1 : this.resultItems.length - 1;
		} else if (key === 'ArrowDown') {
			this.selectedItem =
				this.selectedItem < this.resultItems.length - 1 ? this.selectedItem + 1 : 0;
		}

		this.resultItems.forEach((element: HTMLLIElement, index: number) => {
			if (index === this.selectedItem) {
				element.classList.add('selected');
			} else {
				element.classList.remove('selected');
			}
		});
	}

	private escapeString(str: string): string {
		return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	private renderResults(response: Array<FaqItem>): void {
		let resultHTML: string = '';

		if (response.length === 0) {
			resultHTML += '<li class="no-results">' + this.searchInput.dataset.emptyLabel + '</li>';
		} else {
			const inputValue: string = this.escapeString(this.searchInput.value);
			const expression: RegExp = new RegExp(inputValue, 'i');
			response.forEach((element) => {
				resultHTML += '<li class="result-item">';
				resultHTML += '<a href="' + element.url + '">';
				resultHTML += '<span>' + element.title.replace(expression, '<b>$&</b>') + '</span>';
				resultHTML += '</a>';
				resultHTML += '</li>';
			});
		}
		this.resultContainer.innerHTML = resultHTML;
		this.resultItems = this.container.querySelectorAll('.result-item');
	}
}

const initFaqSearch = () => {
	document.querySelectorAll('.faq-search').forEach((target: HTMLElement) => {
		new FaqSearch(target);
	});
};

if (/complete|interactive|loaded/.test(document.readyState)) {
	initFaqSearch();
} else {
	document.addEventListener('DOMContentLoaded', () => initFaqSearch());
}
